import { type FacetValueBase, Vehicle } from 'Models';
import fitmentSearchConfig from 'Models/uiConfig/fitmentSearchConfig';
import type { VehicleValue } from 'Models/vehicle';
import { loadSelectedVehicle } from 'Utils/userStorage';

import getRequestFromUri, { getRequestFromUriParts, parseUri } from './getRequestFromUri';
import { makeFacetsUri } from './getUriFromRequest';

export function getVehicleFromUri(): { isVehicleNew: boolean; selection: VehicleValue[] } {
  const fitmentFields = fitmentSearchConfig.fields;
  let selection: VehicleValue[] = getRequestFromUri(window.location).selection.filter((v) =>
    fitmentFields.includes(v.field),
  );

  if (!selection.length) {
    try {
      selection = (getRequestFromUriParts(parseUri(window.location)).selection ?? []).filter((v) =>
        fitmentFields.includes(v.field),
      );
    } catch (error) {
      if (!(error instanceof URIError)) {
        throw error;
      }
    }
  }

  return {
    isVehicleNew:
      selection.length > 0 && !loadSelectedVehicle().equals(new Vehicle(selection, fitmentFields)),
    selection,
  };
}

export function getUriWithVehicle(uri: string, selection: FacetValueBase[]): string {
  if (!uri || !selection.length) {
    return uri;
  }

  try {
    const url = new URL(uri, document.baseURI);
    if (url.origin !== window.location.origin) {
      return uri;
    }

    const parts = parseUri(url);
    const destinationSelection = getRequestFromUriParts(parts).selection ?? [];
    if (destinationSelection.some(({ field }) => fitmentSearchConfig.fields.includes(field))) {
      return uri;
    }

    const part =
      !parts.search.rawSelection && (parts.hash.rawSelection || parts.hash.params.facet !== undefined)
        ? 'hash'
        : 'search';
    const existingSelection = getRequestFromUriParts({ ...parts[part], params: {} }).selection ?? [];
    const facets = makeFacetsUri({ selection: [...existingSelection, ...selection] });
    url[part] = [facets, ...parts[part].otherParams].filter(Boolean).join('&');
    return url.href;
  } catch {
    return uri;
  }
}
